<template>
    <table class="upload-pagination">
        <tr>
            <td class="beforeButton tableButton">
                <button class="buttonBefore buttonnav" v-if="before" @click="emitGoPage(page - 1)"><span class="arrow">⇐</span> Anterior</button>
            </td>
            <td class="pageSection tableButton">
                Página: {{ page + 1}}
            </td>
            <td class="afterButton tableButton">
                <button class="buttonAfter buttonnav" v-if="after" @click="emitGoPage(page + 1)">Siguiente <span class="arrow">⇒</span></button>
            </td>
        </tr>
    </table>
</template> 


<script>
export default {
    name: "UploadsPagination",
    mounted() {
    },
    props: {
        page: {
            type: Number,
            required: true,
        },
        before: {
            type: Boolean,
            required: true,
        },
        after: {
            type: Boolean,
            required: true,
        },
        data: {
            type: Array,
            required: true,
        },
    },
    methods: {
        emitGoPage(page) {
            // Emit an 'update-page' event with the new page number
            this.$emit('update-page', page);
        }
    },
};
</script>
<style scoped>
.file_date {
    font-size: 0.8em;
    padding-left: 1em;
    vertical-align: bottom;
}
.file_name {
    font-weight: bold;
}
.file_type {
    padding-left: 1em;
}
.file_button {
    padding-left: 1em; 
}
.tableButton {
    width: 10em;
}
.container-files {
    height: 20em;
}
.buttonnav {
    border: none;
    background-color: #ddd;
    border-radius: 1px;
    font-weight: bold;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}
.buttonnav:hover {
    transform: translateY(-2px);
    filter: drop-shadow(-1px 1px 2px #d0d0d0ff);
}
.buttonnav:active {
    transform: translateY(1px);
}
.buttonBefore:hover {
    background-image: linear-gradient(to right, #ddf 0%, #fff 100%);
}
.buttonAfter:hover {
    background-image: linear-gradient(to left, #ddf 0%, #fff 100%);
}
.buttonBefore:active {
    background-image: linear-gradient(to right, #dff 0%, #fff 100%);
}
.buttonAfter:active {
    background-image: linear-gradient(to left, #dff 0%, #fff 100%);
}
.buttonBefore {
    background-image: linear-gradient(to right, #ddd 0%, #fff 100%);
}
.buttonAfter {
    background-image: linear-gradient(to left, #ddd 0%, #fff 100%);
}
.pageSection {
    font-size: 0.8em;
    padding-top: 0.3em;
    color: #999;
}
.arrow {
    font-size: 1.2em;
    top: -1px;
    position: relative;
}
.upload-pagination {
    text-align: center;
    width: 100%;
}
</style>